<script lang="ts">
    import { _ } from "svelte-i18n"
    import { Router, Route } from "../../../../vendor/svelte-routing"
    import CheckoutHeader from "./checkout/CheckoutHeader.svelte"
    import Shipping from "./checkout/Shipping.svelte"
    import Payment from "./checkout/Payment.svelte"
    import Overview from "./checkout/Overview.svelte"
    import Confirmation from "./checkout/Confirmation.svelte"
    import { cartOverlay } from "../../store"
    import DealerOverview from "./checkout/DealerOverview.svelte"
    import { title } from "../../config"
    import Index from "../SEO/Index.svelte"

    let innerWidth
    let containerWidth

    $: marginRight =
        innerWidth > 1024 && $cartOverlay
            ? innerWidth * (innerWidth > 1300 ? 0.3 : 0.5) + 20 - (innerWidth - containerWidth) / 2
            : 0
</script>

<Index noIndex="{true}" title="{$_('checkout.checkout')}" metaDescription="{$_('meta.description')}" />

<svelte:window bind:innerWidth />

<section class="section-type-1 section_padding checkout">
    <div class="container" bind:clientWidth="{containerWidth}">
        <div class="inner" style="margin-right:{marginRight}px">
            <Router>
                <Route path="">
                    <CheckoutHeader />
                    <Shipping />
                </Route>
                <Route path="payment">
                    <CheckoutHeader />
                    <Payment />
                </Route>
                <Route path="overview">
                    <CheckoutHeader />
                    <Overview />
                </Route>
                <Route path="dealer">
                    <DealerOverview />
                </Route>
                <Route path="confirmation">
                    <Confirmation />
                </Route>
            </Router>
        </div>
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    .inner {
        transition: all 0.3s;
    }
    .checkout :global {
        section {
            margin-bottom: 40px;
            .section_headline {
                font-size: 1.2rem;
                margin-bottom: 15px;
            }
            input,
            textarea,
            select {
                margin-bottom: 0px;
            }
            input:disabled {
                background: var(--comp--input--disabled--background);
                color: var(--comp--input--disabled--color);
            }
            .select_holder {
                position: relative;

                select {
                    height: auto;
                    padding-top: 20px;
                    padding-bottom: 5px;
                    -webkit-appearance: none;
                    background: var(--surface);
                    color: var(--on-surface);
                }

                .placeholder_overlay {
                    position: absolute;
                    top: 3px;
                    left: 21px;
                    font-size: 0.7rem;
                    color: inherit;
                }

                &.no-label {
                    select {
                        padding-top: 8px;
                        padding-bottom: 7px;
                    }
                    .placeholder_overlay {
                        display: none;
                    }
                }

                .right_overlay {
                    position: absolute;
                    top: 10px;
                    bottom: 10px;
                    right: 1px;
                    .flex();
                    align-items: center;
                    justify-content: center;
                    width: 50px;
                    border-left: solid 1px var(--border-color-2);
                    z-index: 0;
                    background-color: var(--surface);
                    color: var(--on-surface);
                    cursor: default;
                    pointer-events: none;

                    svg {
                        color: inherit;
                    }
                }
            }
        }

        .inputholder input[type="checkbox"]:checked ~ label:before {
            background: var(--primary) !important;
        }
        .inputholder label:before {
            border-color: var(--primary) !important;
        }
        .inputholder input[type="radio"]:checked ~ label:after {
            background: var(--primary) !important;
        }
        .checkout_bottom {
            .flex();
            justify-content: space-between;
            align-items: center;
            .linkback {
                .flex();
                align-items: center;
                .icon {
                    .flex();
                    align-items: center;
                    justify-content: center;
                    margin-right: 10px;
                }
            }
        }
    }
</style>
